<template lang="html">
  <div class="client-goals">
    <div class="section-header">
     <div class="row">
       <button @click="$router.push('/dashboard')"><h-icon>arrow_back</h-icon></button> 
       {{client.first_name}}'s Goals
    </div>
    </div>
    <div v-infinite-scroll="findNext" infinite-scroll-disabled="loading" infinite-scroll-distance="15">
      <goal :editable="false" v-for="goal in goals" :goal="goal" :key="goal.id" class="small-top"></goal>
    </div>
    <div class="card card--white" v-if="goals.length == 0">
      <div class="card--container">
        <span v-if="loading"><v-progress-circular indeterminate color="primary"></v-progress-circular>Loading</span>
        <span v-if="!loading">Doesn't look like they're working on any goals</span>
      </div>
    </div>
  </div>
</template>

<script>
import Paginator from "@/services/api/paginator";
import goal from "@/components/goals";
import store from "@/services/api/store";

export default {
  components: {
    goal
  },
  data() {
    return {
      goals: [],
      client: {},
      loading: false
    };
  },
  created() {
    store.find("CoachClients", this.$route.params.id)
      .then(client => {
        this.client = client;
      });

    let opts = { user: this.$route.params.id };
    if (!this.all) {
      opts.abandoned = false;
      opts.progress__lt = 100;
    }
    this.pagination = new Paginator("CoachClientGoals", opts);
  },
  methods: {
    findNext() {
      if (!this.pagination.finished && !this.loading) {
        this.loading = true;
        this.pagination.next().then(goals => {
          this.goals = [...this.goals, ...goals];
        }).finally(() => this.loading = false);
      }
    }
  }
};
</script>

<style lang="less" scoped>
.small-top {
  margin-top: 10px;
}
</style>
